import React, { useState } from "react";

import FindImg from "../assets/images/UIfindloan.png";
import FundImg from "../assets/images/UIfundloan.png";
import TradeImg from "../assets/images/UIportfolio.png";


const steps = [
  {
    subtitle: "Find a loan.",
    body: "Pick the loan that fits you. No black boxes, no blind trust. Filter by grade, APY, and more. Open any loan to see the details before you commit.",
  },
  {
    subtitle: "Fund a loan.",
    body: "Expand a listing to explore everything from APY to year built. Choose how much to deposit, then click fund.",
  },
  {
    subtitle: "Trade a loan.",
    body: "You'll receive tokens representing your share of the loan and its cashflow. Hold for yield, or exit anytime by selling your shares.",
  },
];

export default function HowItWorksMobile() {
  const [active, setActive] = useState(0);

  const prev = () => setActive((n) => Math.max(0, n - 1));
  const next = () => setActive((n) => Math.min(steps.length - 1, n + 1));

  // Swipe support
  const touchStartX = React.useRef(null);
  const onTouchStart = (e) => { touchStartX.current = e.touches[0].clientX; };
  const onTouchEnd = (e) => {
    if (touchStartX.current == null) return;
    const dx = e.changedTouches[0].clientX - touchStartX.current;
    if (dx < -40) next();
    if (dx > 40) prev();
    touchStartX.current = null;
  };

  const images = [
    <img src={FindImg} alt="Find a loan" style={{ width: "100%", height: "100%", objectFit: "cover" }} />,
    <img src={FundImg} alt="Fund a loan" style={{ width: "100%", height: "100%", objectFit: "cover" }} />,
    <img src={TradeImg} alt="Trade a loan" style={{ width: "100%", height: "100%", objectFit: "cover" }} />,
  ];

  return (
    <section
      style={{ background: "rgba(24, 21, 20, 1)", padding: "60px 0 80px" }}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
    >
      {/* Header */}
      <div style={{ padding: "0 6vw", marginBottom: "32px" }}>
        <div style={{ color: "rgba(255,255,255,0.45)", fontSize: "12px", letterSpacing: "0.1em", textTransform: "uppercase", marginBottom: "10px" }}>
          How it works
        </div>
        <h2 style={{ color: "#FFFFFF", fontSize: "28px", fontWeight: "bold", lineHeight: 1.2, margin: 0 }}>
          {steps[active].subtitle}
        </h2>
      </div>

      {/* Image slot */}
      <div
        style={{
          width: "88vw",
          margin: "0 auto 28px",
          borderRadius: "16px",
          overflow: "hidden",
          background: "rgba(255,255,255,0.06)",
          aspectRatio: "16/10",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {images[active] ?? (
          // placeholder — remove this once you slot in real images
          <div style={{ color: "rgba(255,255,255,0.2)", fontSize: "14px" }}>
            UI mock {active + 1}
          </div>
        )}
      </div>

      {/* Body text */}
      <div style={{ padding: "0 6vw", marginBottom: "36px" }}>
        <p style={{ color: "rgba(255,255,255,0.75)", fontSize: "16px", lineHeight: 1.7, margin: 0 }}>
          {steps[active].body}
        </p>
      </div>

      {/* Navigation */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 6vw" }}>
        {/* Dots */}
        <div style={{ display: "flex", gap: "8px" }}>
          {steps.map((_, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              style={{
                width: i === active ? "24px" : "8px",
                height: "8px",
                borderRadius: "4px",
                background: i === active ? "#FFFFFF" : "rgba(255,255,255,0.25)",
                border: "none",
                padding: 0,
                cursor: "pointer",
                transition: "width 0.3s ease, background 0.3s ease",
              }}
            />
          ))}
        </div>

        {/* Prev / Next */}
        <div style={{ display: "flex", gap: "12px" }}>
          <button
            onClick={prev}
            disabled={active === 0}
            style={{
              width: "44px", height: "44px", borderRadius: "50%",
              background: active === 0 ? "rgba(255,255,255,0.08)" : "rgba(255,255,255,0.18)",
              border: "none", color: "#FFFFFF", fontSize: "18px",
              cursor: active === 0 ? "default" : "pointer",
              opacity: active === 0 ? 0.4 : 1,
              transition: "opacity 0.2s",
            }}
          >
            ←
          </button>
          <button
            onClick={next}
            disabled={active === steps.length - 1}
            style={{
              width: "44px", height: "44px", borderRadius: "50%",
              background: active === steps.length - 1 ? "rgba(255,255,255,0.08)" : "rgba(255,255,255,0.18)",
              border: "none", color: "#FFFFFF", fontSize: "18px",
              cursor: active === steps.length - 1 ? "default" : "pointer",
              opacity: active === steps.length - 1 ? 0.4 : 1,
              transition: "opacity 0.2s",
            }}
          >
            →
          </button>
        </div>
      </div>
    </section>
  );
}
